import { HTTPClient } from '@abaco/web-common/src/HTTP';
import axios, { CancelTokenSource } from "axios";
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { Building, BuildingOut, BuildingFilter, BuildingType, ProductionAreaOut, ProductionAreaUpdateOut, BuildingGeometry, Council, ProductionArea } from '../models/Building';
import { UnitOfMeasure } from '../models/UnitsOfMeasure';
import { Staff } from '../models/Staff';

export default class StaffApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    // public async getStaff(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Staff>>{
    public async getStaff(pk_cuaa: number, filter: string | null): Promise<Staff[]>{
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel();
        }
        this.cancelTokenSource = axios.CancelToken.source();
        const filterArr = [];
        if (filter) {
            filterArr.push(`^search_string like ${filter.toUpperCase()}`);
        }

        // const res = await this.http.get(`${this.rootPath}/v1/buildings/subjects/${pk_cuaa}/buildings`, {
        //     params: {
        //         offset: paging.offset,
        //         count: paging.count,
        //         filter: filterArr.length > 0 ? filterArr : undefined,
        //     }
        // });
        const res = await this.http.get(`${this.rootPath}/v1/buildings/subjects/${pk_cuaa}/buildings`, {
            params: {
                offset: 0,
                count: 300,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        });

        //DUMMY DATA
        res.data = [];
        for (let i = 0; i < 10; i++) {
            const e: Staff = {
                username: i % 2 ? "administrator" : "base_user",
                email: i % 2 ? "admin@hotmail.it" : "basic_asd@gmail.com",
                name: "NIDMA",
                surname: "STRATOR",
                fiscal_code: i % 2 ? "04938586866" : "VBHFJIGSJISDMG",
                hour_type: i % 2 ? "Orario mattino" : "Orario pomeriggio",
            };
            res.data.push(e);
        }
        return res.data;
    }

}
